import React from 'react';
import styled, { useTheme } from 'styled-components';

import type { ToolsBlock as T } from './types';
import { blockPadV, blockPadH, blockW } from 'theme/mixins/padding';
import Icon from 'components/Icons/Icon';
import { IconNames } from 'components/Icons/IconList';

const Wrapper = styled.div`
  ${() => blockPadV()};
  ${() => blockPadH()};
`;

const Container = styled.div`
  ${() => blockW()};
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`;

const Title = styled.p`
  font-family: ${({ theme }) => theme.fontStacks.sans};
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 2.25rem !important;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2rem;
  width: 100%;

  ${({ theme }) => theme.mq.sm`
    width: unset;
    grid-template-columns: repeat(6, 1fr);
  `};
`;

const StyledLink = styled.a`
  width: fit-content;
`;

const StyledIcon = styled(Icon)`
  path {
    stroke: none;
  }
`;

const ToolsBlock: React.FC<T> = ({ title, tools }) => {
  const theme = useTheme();

  if (!tools) {
    return null;
  }

  return (
    <Wrapper>
      <Container>
        <Title>{title}</Title>
        <GridContainer>
          {tools.map(
            (item, idx) =>
              item && (
                <StyledLink target="_blank" href={item.url || ''} rel="noopener noreferrer">
                  <StyledIcon
                    name={item.toolIcon as IconNames}
                    color={theme.themeColors.fg}
                    key={`${item.toolIcon}-${idx}`}
                  />
                </StyledLink>
              )
          )}
        </GridContainer>
      </Container>
    </Wrapper>
  );
};

export default ToolsBlock;
